module.exports = __webpack_public_path__ + "static/media/StarterPack.24c7d988.png";